export enum ScreensAddBlock {
  Root = 'ScreensAdd',
  ScreensAddLinks = 'ScreensAddLinks',
}
